<template>
  <div class="edit-vv-card-content">
    <div class="edit-virtual-virtual-header-container">
      <button type="button" @click="toggleActionModal(false)">
        <img
          src="@shared/assets/img/general/x-white.png"
          class="edit-vv-exit"
          alt="x"
        />
      </button>
    </div>
    <div class="edit-virtual-virtual-body-container">
      <button type="button" class="edit-vv-button" @click="viewVideo">
        <img
          :src="selectedVirtualVisit.thumbnailUrl"
          class="edit-vv-thumbnail"
          alt="icon"
        />
        <span class="edit-vv-play-container">
          <img
            src="@shared/assets/img/general/blue-play-btn.svg"
            class="edit-vv-play-btn"
            alt="play"
          />
        </span>
      </button>
    </div>
    <div class="edit-virtual-visit-footer-container">
      <div class="flex-column width-100 pr-16">
        <div class="edit-vv-footer-btm">Virtual Visit</div>
        <div class="edit-vv-recorded-date">
          {{ formatDate(selectedVirtualVisit.recordedDate) }}
        </div>
        <div class="sve-input-container">
          <button
            v-if="!editing"
            class="sve-button-container"
            type="button"
            @click="handleInput('editing', true)"
          >
            <span class="icon-luc-Pencil sac__font-18 f-primary" />
          </button>
          <button
            v-if="editing"
            class="sve-button-container"
            @click="saveNote"
            type="button"
            :disabled="dashboardNotes.length === 0"
          >
            <span
              :class="`icon-luc-Check sac__font-18 ${
                dashboardNotes.length === 0 ? 'n60' : 'f-primary'
              }`"
            />
          </button>
          <textarea
            field="dashboardNotes"
            class="note-box"
            :disabled="!editing"
            placeholder="Add a Note here..."
            v-model="dashboardNotes"
            maxlength="250"
          />
          <div class="sve-count-container">{{ dashboardNotes.length }}/250</div>
        </div>
        <div
          v-if="customer.technicianId && selectedTech"
          class="edit-vv-tech-info-row"
        >
          <img
            v-if="selectedTech.profileUrl"
            :src="technicianAvatar"
            class="edit-vv-tech-profile"
            alt="tech"
          />
          <div class="edit-vv-tech-name">
            <u>{{ selectedTech.firstName + ' ' + selectedTech.lastName }}</u>
            - Technician
          </div>
        </div>
      </div>
      <div v-if="adminRole !== 'viewer'" class="vv-edit-footer-btns">
        <button
          type="button"
          class="edit-vv-tech-info-row"
          @click="toggleActionModal(true, 'send-virtual-visit')"
        >
          <img
            src="@shared/assets/img/general/plane.svg"
            class="vv-footer-plane"
            alt="plane"
          />
          <span class="edit-vv-btn-txt-send"> Send to Member </span>
        </button>
        <button
          type="button"
          class="edit-vv-tech-info-row"
          @click="toggleActionModal(true, 'delete-visit')"
        >
          <img
            src="@shared/assets/img/general/trash-white.png"
            class="vv-footer-delete"
            alt="delete"
          />
          <span class="edit-vv-btn-txt-delete"> Delete Virtual Visit </span>
        </button>
      </div>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Sending Virtual Visit"
      overlayClass="ac-overlay"
    />
  </div>
</template>
<script>
import moment from 'moment';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'EditVirtualVisit',
  components: {
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      editing: false,
      processing: false,
      dashboardNotes: '',
    };
  },
  computed: {
    selectedTech() {
      return this.selectedTechnician;
    },
  },
  watch: {
    selectedVirtualVisit: {
      immediate: true,
      handler(val) {
        this.dashboardNotes = val.dashboardNotes || '';
      },
    },
  },
  methods: {
    formatDate(recordedDate) {
      return moment(recordedDate).format('LL');
    },
    handleInput(field, value) {
      this[field] = value;
    },
    viewVideo() {
      window.open(this.selectedVirtualVisit.sharedUrl, '_blank');
    },
    saveNote() {
      this.processing = true;
      this.$store
        .dispatch('updateVirtualVist', {
          virtualVisit: {
            ...this.selectedVirtualVisit,
            dashboardNotes: this.dashboardNotes,
          },
        })
        .then(() => {
          this.$store.dispatch('showSuccessToast', {
            message: 'Notes updated',
          });
          this.processing = false;
        })
        .finally(() => {
          this.editing = false;
        });
    },
  },
};
</script>
<style lang="scss">
.edit-vv-card-content {
  background-color: $PRIMARY;
  display: flex;
  flex-direction: column;
  height: 100%;
  animation: fadeIn 0.5s ease;
  position: relative;
  border-radius: 8px;
}

.edit-virtual-virtual-header-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  background-color: $PRIMARY;
  padding: 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  .edit-vv-exit {
    width: 24px;
    height: 24px;
  }
}

.edit-virtual-virtual-body-container {
  width: 100%;
  padding: 0 16px;
  background-color: $PRIMARY;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;

  .edit-vv-button {
    position: relative;
    width: 800px;
    height: 452px;
  }

  .edit-vv-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .edit-vv-play-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .edit-vv-play-btn {
    width: 256px;
    height: 256px;
  }
}

.edit-virtual-visit-footer-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: $PRIMARY;
  width: 100%;
  padding-left: 16px;

  .note-box {
    border-radius: 8px;
    height: 115px;
    width: 100%;
    margin-top: 15px;
    margin-bottom: 12px;
    background-color: #f0f5fa;
    padding-left: 10px;
    padding-top: 10px;
    padding-right: 10px;
  }
  .sve-input-container {
    flex: 1;
    position: relative;

    .sve-button-container {
      position: absolute;
      top: 18px;
      right: 3px;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      text-align: right;
      padding: 4px 6px;
      background-color: $WHITE;
    }
    .sve-count-container {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      text-align: right;
      padding: 0 8px 8px 0;
      font-size: 0.75rem;
      color: $N40;
    }
  }
  .edit-vv-footer-btm {
    margin-top: 10px;
    color: $WHITE;
    font-size: 24px;
    font-weight: 600;
    line-height: 1;
  }

  .edit-vv-recorded-date {
    margin-top: 10px;
    color: $WHITE;
    font-size: 32px;
    font-weight: 600;
    line-height: 1;
  }

  .flex-column {
    margin-top: 15px;
  }

  .vv-edit-footer-btns {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
  }

  .edit-vv-tech-info-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    margin-top: 10px;
    margin-right: 16px;
    margin-bottom: 10px;

    .edit-vv-tech-profile {
      width: 24px;
      height: 24px;
      border-radius: 30px;
    }

    .edit-vv-tech-name {
      margin-left: 10px;
      font-size: 16px;
      color: $WHITE;
    }

    .edit-vv-btn-txt-send {
      text-decoration: underline;
      margin-left: 10px;
      font-size: 13px;
      font-weight: 400;
      color: $WHITE;
    }

    .edit-vv-btn-txt-delete {
      margin-left: 5px;
      font-size: 13px;
      font-weight: 400;
      color: $WHITE;
    }

    .vv-footer-plane {
      width: 24px;
      height: 21px;
    }

    .vv-footer-delete {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
